// extracted by mini-css-extract-plugin
export default {"button":"FormButton_button__7gC40"};